<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'visibility',
    mixins: [baseOption],

    data() {
        return {
            checked: true,
            displayName: 'Visibility',

            messages: {
                checked: 'Visible',
                unchecked: 'Hidden',
            },

            tailwindDefinitionProp: 'display',
        };
    },

    methods: {
        onInput(isChecked) {
            let flexClassNew;

            if (isChecked) {
                switch (this.screen) {
                    case 'lap':
                    case 'tab':
                    case 'mob':
                        this.selectedElements.forEach((element) => {
                            const allScreenClass = element.flexClassCollection[this.tailwindDefinitionProp].all.default;
                            const allScreenClassDefinition = getClassDefinition(allScreenClass);

                            // only add a screen-specific display class when there's a hidden class set for "all screens"
                            if (allScreenClassDefinition.value !== 'hidden') {
                                this.removeFlexClass();
                                return;
                            }

                            const className = generateClass({
                                value: element.cssDisplay,
                                screen: this.screen,
                                tailwindDefinitionProp: this.tailwindDefinitionProp,
                            });

                            element.currentPreset = '';
                            element.flexClassCollection[this.tailwindDefinitionProp][this.screen].default = className;
                        });

                        this.clearPresets();
                        break;

                    default:
                        // don't add any display classes if in "all screens" mode
                        this.removeFlexClass();
                }
            } else {
                flexClassNew = this.addFlexClass({
                    value: 'hidden',
                });
            }

            this.checked = isChecked;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            const screenPrefix = this.screen === 'all' ? '' : `${ this.screen }:`;

            const HIDDEN_CLASS_BASE = 'f-hidden';
            const HIDDEN_CLASS = `${ screenPrefix }${ HIDDEN_CLASS_BASE }`;
            const BLOCK_CLASS = `${ screenPrefix }f-block`;

            const allHidden = this.flexClassGroup.all.default === HIDDEN_CLASS_BASE;
            const screenHidden = this.flexClassGroup[this.screen].default === HIDDEN_CLASS;
            const displayBlockExists = this.flexClassCollection.display[this.screen].default === BLOCK_CLASS;

            this.checked = displayBlockExists || (!allHidden && !screenHidden);
        },
    },
};
</script>
